import React, { useContext } from 'react';
import { Line } from 'react-chartjs-2';
import { LanguageContext } from '../LanguageContext';

function LineChartComponent({ data, name, statelabels=null, regressionData=null, timeUnit='day', stepped=false}) {
  const { t } = useContext(LanguageContext);
  const isPercentChart = name === 'filter_usage_history';
  const beginAtZero = isPercentChart || name === 'daily_completed_processes';
  
  const datasets = [
    {
      label: t(name),
      data: data,
      fill: false,
      borderColor: '#0099ff',
      stepped,
      tension: 0.1,
    }
  ];
  

  
  if (name.includes('pressure') && data && data.length > 0) {
    const firstTime = data[0]?.x;
    const lastTime = data[data.length - 1]?.x;
    if (firstTime && lastTime) {
      datasets.push({
        label: `${t('threshold')}`,
        data: [
          { x: firstTime, y: 480 },
          { x: lastTime, y: 480 }
        ],
        fill: false,
        borderColor: '#ff0000',
        borderDash: [10, 5],
        tension: 0,
        pointRadius: 0,
      });
    }
  }
  
  const chartData = {
    datasets: datasets,
  }; 

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false, // Wyłącz animacje
    scales: {
      x: {
        type: 'time',
        time: {
          unit: timeUnit,
          displayFormats: {
            day: 'yyyy-MM-dd', // Format bez AM/PM, np. 2025-07-02
            hour: 'HH:mm', // Gdyby pojawiły się godziny
            minute: 'HH:mm',
          },
          tooltipFormat: timeUnit === 'day' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 7,
        },
      },
      y: {
        beginAtZero,
        ticks: {
            stepSize: 1,
            callback: function(value) {
            const label = statelabels?.[value] ?? value;
            return isPercentChart ? `${label}%` : label;
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.dataset.label ? `${context.dataset.label}: ` : '';
            const value = context.parsed?.y;
            if (value === null || value === undefined) {
              return label;
            }
            return isPercentChart ? `${label}${value}%` : `${label}${value}`;
          },
        },
      },
    },
  };
  
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default React.memo(LineChartComponent);
